module.exports = __webpack_public_path__ + "img/drzwi2.cae235b1.jpg";